module.exports = __webpack_public_path__ + "static/media/load-sign.db365d10.png";